export default __webpack_public_path__ + "static/media/MaskGroup343.abd9c85a.png";